import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { OrgOverviewState, OrgPlan, OrgStats } from './types';

const initialState: OrgOverviewState = {
  plan: null,
  stats: null,
  loading: false,
  error: null
};

export const slice = createSlice({
  name: 'orgOverview',
  initialState,
  reducers: {
    startLoading(state) {
      state.loading = true;
      state.error = null;
    },
    hasError(state, action: PayloadAction<string>) {
      state.error = action.payload;
      state.loading = false;
    },
    getOrgOverviewSuccess(state, action: PayloadAction<{ plan: OrgPlan; stats: OrgStats }>) {
      state.plan = action.payload.plan;
      state.stats = action.payload.stats;
      state.loading = false;
    }
  }
});

export default slice.reducer;
